// 客户费率列表
import { HttpExpressFeeList, HttpConfirmExpressFee } from '@/service/chargescalc';
import TableList from "@components/templates/tablelist";
import compConfirmBill from '../billsummary/confirmbill.vue'
import { mapState, mapGetters } from 'vuex';
import mixin from "../mixin";

export default {
    mixins: [TableList, mixin],
    components: {
        compConfirmBill
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpExpressFeeList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'confirm':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "确认账单",
                        width: 400,
                        params: {
                            id: params.id,
                            totalCost: params.totalAmount,
                            type: 'expressfee'
                        },
                        component: "compConfirmBill",
                        showFooter: false,
                    };
                    // this.operate = {
                    //     show: true,
                    //     alert: "info",
                    //     title: "确认账单",
                    //     width: 400,
                    //     desc: '请确认账单金额USD ' + params.totalCost + '是否准确？',
                    //     showDesc: true,
                    //     params: {
                    //         id: params.id,
                    //     },
                    //     ajaxRequest: HttpConfirmExpressFee,
                    // };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/newBilling/billPayableDelivery/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'get',
                    })
                    break;
                case 'downloadInvoice':
                    this.handleWebfs(params.invoiceFileUrl, 'download')
                    break;
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, billStatus, totalAmount, invoiceFileUrl } = row;
            return [
                {
                    label: this.$t('', { defaultValue: "导出账单" }),
                    show: true,
                    params: { id },
                    operate: 'export'
                },
                {
                    label: this.$t('fbb.billmanage.confirm_bill', { defaultValue: "确认账单" }),
                    show: billStatus == 0,
                    params: { id, totalAmount },
                    operate: 'confirm'
                },
                {
                    label: this.$t('', { defaultValue: "下载发票" }),
                    show: true,
                    params: { invoiceFileUrl },
                    operate: 'downloadInvoice'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getUserManageWarehouseList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "gray",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    options: [
                        { value: 'FedEx', label: 'FedEx'},
                        { value: 'UPS', label: 'UPS'},
                    ],
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('', { defaultValue: "账单状态" }),
                    key: 'EQ_billStatus',
                    tag: 'vSelect',
                    show:true,
                    options: [
                        { value: 0,label: '待确认'},
                        { value: 1,label: '已确认'}
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                    key: 'EQ_account',
                    tag: 'vInput',
                },
                {
                    label: this.$t('',{defaultValue:'账单日期'}),
                    tag: 'vDatepicker',
                    key: 'BT_billDate',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: '到期日期',
                    tag: 'vDatepicker',
                    key: 'BT_expireDate',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
                    key: 'account',
                },
                {
                    title: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
                    key: 'billNo',
                },
                {
                    title: this.$t('fbb.delivery.totalCost',{defaultValue:'账单总额'}),
                    key: 'totalAmount',
                },
                {
					title: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency',
				},
                {
                    title: this.$t('', { defaultValue: "账单状态" }),
                    render: (h,{row})=>{
                        return <div>{row.billStatus == 1 ? '已确认' : '待确认'}</div>
                    }
                },
                {
                    title: this.$t('',{defaultValue:'账单日期'}),
                    sortable: true,
                    render: (h, {row})=>{
                        return <div>{row.billDate}</div>
                    }
                },
                {
                    title: this.$t('',{defaultValue:'到期日期'}),
                    sortable: true,
                    render: (h, {row})=>{
                        return <div>{row.expireDate}</div>
                    }
                },
                {
                    title: this.$t('', { defaultValue: '确认人' }),
                    key: 'confirmBy'
                },
                {
                    title: this.$t('', { defaultValue: '确认时间' }),
                    key: 'confirmAt'
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




